import React from "react";
import { Undo } from "@mui/icons-material";

import { HistoryContext, useHistoryContext } from "fond/history";

import { IButtonProps } from "./Toolbar";
import ToolbarButton from "./ToolbarButton";

const UndoButton: React.FC<IButtonProps> = ({ icon, mode, title = "Undo" }) => {
  const { canUndo, undo } = useHistoryContext(HistoryContext);
  const isDisabled = !canUndo || (!!mode && !["simple_select", "direct_select", "static", "draw_point"].includes(mode));

  const handleOnClick = () => {
    undo();
  };

  return (
    <ToolbarButton title={title} onClick={handleOnClick} disabled={isDisabled} data-testid="toolbar-undo-button">
      {icon || <Undo />}
    </ToolbarButton>
  );
};

export default UndoButton;
